
import { processPostBody } from 'bits/post_processing'
import { Component, Prop, Vue, Watch } from 'bits/vue'
import emitClickOnTouch from 'vuedirectives/emit_click_on_touch'

@Component({
  directives: {
    emitClickOnTouch,
  },
})
export default class SurfacePostBody extends Vue {
  $refs!: {
    postBody: HTMLParagraphElement
  }

  @Prop({ required: true }) content!: string
  @Prop({ default: 'auto' }) darkMode!: boolean | 'auto'
  @Prop({ default: false }) isTextSelectable!: boolean

  body = ''

  mounted(): void {
    this.performPostUpdateActions()
  }

  @Watch('content')
  onContentChange(): void {
    this.performPostUpdateActions()
  }

  async performPostUpdateActions(): Promise<void> {
    this.body = await processPostBody(this.content, this.$refs.postBody)
  }
}
